import React, { useState } from 'react';

const Upload: React.FC = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleProcessFile = () => {
    if (!selectedFile) {
      alert('Please select a file');
      return;
    }

    setIsProcessing(true);
    // TODO: Implement file processing logic
    setTimeout(() => {
      setIsProcessing(false);
      alert('File processing will be implemented in the next phase');
    }, 1000);
  };

  return (
    <section className="p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
          Upload Data
        </h1>
      </div>

      {/* Upload Card */}
      <div className="rounded-lg shadow p-6" style={{ background: 'var(--bg-secondary)' }}>
        <div className="font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
          Upload CSV / Excel
        </div>

        <div className="space-y-4">
          <div>
            <input
              type="file"
              accept=".csv,.xlsx,.xls"
              onChange={handleFileSelect}
              className="border rounded p-2 w-full"
              style={{
                background: 'var(--bg-secondary)',
                color: 'var(--text-primary)',
                borderColor: 'var(--border-color)'
              }}
            />
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={handleProcessFile}
              disabled={!selectedFile || isProcessing}
              className="px-4 py-2 rounded font-medium disabled:opacity-50 disabled:cursor-not-allowed"
              style={{
                background: 'var(--btn-bg)',
                color: 'var(--btn-text)'
              }}
            >
              {isProcessing ? 'Processing...' : 'Process File'}
            </button>

            {selectedFile && (
              <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                Selected: {selectedFile.name}
              </span>
            )}
          </div>

          <div className="text-xs" style={{ color: 'var(--text-secondary)' }}>
            Tip: Include columns like Job, Part, Machine, Good, Scrap, Downtime, Operator.
          </div>
        </div>
      </div>

      {/* Instructions Card */}
      <div className="rounded-lg shadow p-6" style={{ background: 'var(--bg-secondary)' }}>
        <h2 className="text-lg font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
          File Upload Instructions
        </h2>

        <div className="space-y-3">
          <div>
            <h3 className="font-medium mb-2" style={{ color: 'var(--text-primary)' }}>
              Supported Formats:
            </h3>
            <ul className="text-sm space-y-1" style={{ color: 'var(--text-secondary)' }}>
              <li>• CSV files (.csv)</li>
              <li>• Excel files (.xlsx, .xls)</li>
            </ul>
          </div>

          <div>
            <h3 className="font-medium mb-2" style={{ color: 'var(--text-primary)' }}>
              Expected Columns:
            </h3>
            <ul className="text-sm space-y-1" style={{ color: 'var(--text-secondary)' }}>
              <li>• <strong>Job ID</strong> - Job or work order identifier</li>
              <li>• <strong>Part ID</strong> - Part number or product code</li>
              <li>• <strong>Machine ID</strong> - Machine or equipment identifier</li>
              <li>• <strong>Operator</strong> - Operator name or ID</li>
              <li>• <strong>Good Qty</strong> - Number of good parts produced</li>
              <li>• <strong>Scrap Qty</strong> - Number of scrapped parts</li>
              <li>• <strong>Downtime</strong> - Downtime in minutes</li>
              <li>• <strong>Date</strong> - Production date</li>
            </ul>
          </div>

          <div>
            <h3 className="font-medium mb-2" style={{ color: 'var(--text-primary)' }}>
              Notes:
            </h3>
            <ul className="text-sm space-y-1" style={{ color: 'var(--text-secondary)' }}>
              <li>• Column names are automatically mapped based on keywords</li>
              <li>• You can review and adjust the field mapping before import</li>
              <li>• Extra columns will be preserved as additional data</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Mapper Area - This will be populated when file is processed */}
      <div id="mapperArea"></div>
    </section>
  );
};

export default Upload;